import { FocusLayoutProps } from '@livekit/components-react';
import { ParticipantTile } from './ParticipantTile';

export function FocusLayout({ trackRef, ...htmlProps }: FocusLayoutProps) {
  return <ParticipantTile trackRef={trackRef} {...htmlProps} />;
}
